import colors from './colors';
import fonts from './fonts';

const foundationConfigs = [colors, fonts];
export default foundationConfigs;
